import React, { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import ThemeContext from '../../../providers/ThemeProvider';
import ButtonForm from '../../_generic/button/CTAButton';
import Tile from '../../_generic/tile/Tile';
import TileBody from '../../_generic/tile/TileBody';
import Wallet from '../../wallet/Wallet';
import WalletTitle from '../../wallet/WalletTitle';
import GiftForm from '../form/GiftForm';
import GiftTitle from '../title/GiftTitle';

const GiftCard = ({ infoCard, redeemCard, walletCard, walletImg }) => {
  const theme = useContext(ThemeContext);
  const userWallet = useSelector((state) => state.wallet.userWallet);

  const { giftCardTitle, giftCardTxt } = infoCard;
  const {
    redeemTitle,
    claimGiftImg,
    claimGiftImgAlt,
    redeemTxt,
    form,
  } = redeemCard;
  const [hasWallet, setHasWallet] = useState([]);
  const { walletHeader, walletContent, walletBtn } = walletCard[
    process.env.NEXT_PUBLIC_SITE
  ];
  const isCountryGb = process.env.NEXT_PUBLIC_COUNTRY_CODE === 'gb';

  useEffect(() => {
    setHasWallet(userWallet);
  }, [userWallet]);

  return (
    <div className="container">
      <div className="gift-card">
        <div className="gift-card__container">
          <Tile title={giftCardTitle}>
            <TileBody>
              <div
                className="gift-card__content"
                dangerouslySetInnerHTML={{
                  __html: giftCardTxt[process.env.NEXT_PUBLIC_BRAND],
                }}
              />
            </TileBody>
          </Tile>
        </div>
        {!hasWallet.length && (
          <div className="gift-card__container">
            <Tile
              title={
                <GiftTitle
                  img={claimGiftImg}
                  imgAlt={claimGiftImgAlt}
                  title={redeemTitle}
                />
              }
            >
              <TileBody>
                <div
                  dangerouslySetInnerHTML={{
                    __html: redeemTxt[process.env.NEXT_PUBLIC_BRAND],
                  }}
                />
                <GiftForm {...form} />
              </TileBody>
            </Tile>
          </div>
        )}
        {hasWallet.length > 0 && (
          <div className="gift-card__container">
            <Tile title={<WalletTitle {...walletHeader} />}>
              <TileBody>
                <Wallet
                  {...walletContent}
                  balance={userWallet[isCountryGb ? 0 : 1].balance}
                  currencySymbol={isCountryGb ? '£' : '€'}
                  img={walletImg}
                  userWallet={userWallet}
                />
                <ButtonForm
                  className="uppercase full-width wallet"
                  onClick={(event) => {
                    event.preventDefault();
                    setHasWallet([]);
                  }}
                >
                  {walletBtn}
                </ButtonForm>
              </TileBody>
            </Tile>
          </div>
        )}
      </div>
      <style jsx>{`
        .gift-card {
          display: flex;
        }
        .gift-card__container {
          padding: 0 15px;
          width: 50%;
        }
        .container {
          padding: 0;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .gift-card {
            flex-wrap: wrap;
            flex-direction: column-reverse;
          }
          .gift-card__container {
            width: 100%;
            padding: 0;
          }
        }
      `}</style>
      <style global jsx>{`
        .gift-card__spacer {
          display: block;
          float: right;
          width: 160px;
          height: 40px;
        }
        .gift-card__content ul {
          margin: 0 0 16px 16px;
          padding: 0;
          list-style: none;
          text-indent: -19px;
        }
        .gift-card__content li {
          margin: 0 0 8px 0;
        }
        .gift-card__content li:before {
          content: '';
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          background: ${theme.colors.primary};
          margin-right: 10px;
        }
        .gift-card__content a {
          color: ${theme.colors.primary};
          text-decoration: none;
        }
        .gift-card__content a:hover {
          color: #23527c;
          text-decoration: underline;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .gift-card__spacer {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default GiftCard;
